import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Header, Segment, Button, Dropdown, Grid, Pagination} from 'semantic-ui-react';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {DeleteModal} from 'app-ui-componentlibrary';
import REST from 'go/requests/rest';

const emptyStr = '';
const PAGE_SIZE = 25;
export class Whitelist extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      whitelistData: [],
      activePage: 1,
      pageSize: PAGE_SIZE,
    };
  }

  componentDidMount() {
    this.refreshData();
  }

  getAllWhitelist() {
    return REST.config
      .getAllWhitelist()
      .then(REST.handler.handleResponse)
      .then((res) => {
        if (_.size(res) === 0) {
          this.setState({
            error: true,
          });
        } else {
          this.setState({
            whitelistData: [...res],
            error: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          error: true,
        });
      });
  }

  createWhitelist = (body) => {
    return REST.config
      .createWhitelist(body)
      .then(REST.handler.handleResponse)
      .catch((err) => {
        this.setState({error: true});
      });
  };

  updateWhitelist = (whitelistId, body) => {
    return REST.config
      .updateWhitelist(whitelistId, body)
      .then(REST.handler.handleResponse)
      .catch((err) => {
        this.setState({error: true});
      });
  };

  deleteWhitelist = (whitelistId) => {
    return REST.config
      .deleteWhitelist(whitelistId)
      .then(REST.handler.handleResponse)
      .catch((err) => {
        this.setState({error: true});
      });
  };

  logAction = (action, data) => {
    let payload = {
      userId: this.props.currUserEmail,
      action: 'whitelist|' + action,
      payload: data,
    };
    return REST.admin
      .logAction(payload)
      .then(REST.handler.handleResponse)
      .catch((err) => {
        this.setState({error: true});
      });
  };

  handleEditModal = (data) => {
    this.setState({
      openModal: true,
      deleteModalOpen: false,
      showModal: 'Edit',
      data: data,
    });
  };

  handleAddModal = () => {
    this.setState({
      openModal: true,
      showModal: 'Add',
      data: {
        whitelistId: emptyStr,
        fundingOpportunityId: emptyStr,
        process: emptyStr,
        task: emptyStr,
        whitelistUsers: [],
      },
    });
  };

  refreshData() {
    this.setState({
      openModal: false,
      deleteModalOpen: false,
      showModal: false,
      error: false,
      data: {},
    });

    this.getAllWhitelist();
  }

  handleChange = (index, res) => {
    const {name, value} = res;

    let updatedData = this.state.data;
    updatedData[name] = value;
    this.setState({
      data: updatedData,
    });
  };

  handleSubmit = (e) => {
    if (this.state.showModal === 'Edit') {
      this.updateWhitelist(e.whitelistId, this.payload(e)).then((res) => {
        // this.logAction('edit', this.payload(e));
        this.refreshData();
      });
    } else {
      this.createWhitelist(this.payload(e)).then((res) => {
        // this.logAction('create', this.payload(e));
        this.refreshData();
      });
    }
  };

  handleDelete = (data, index) => {
    let updatedData = this.state.whitelistData;
    _.remove(updatedData, this.state.whitelistData[index]);
    this.deleteWhitelist(data.whitelistId).then((res) => {
      // this.logAction('delete', data);
      this.refreshData();
    });
  };

  payload(data) {
    let whitelistUsers = data.whitelistUsers;
    if (!_.isArray(data.whitelistUsers)) whitelistUsers = data.whitelistUsers.split(',');
    return {
      whitelistId: data.whitelistId,
      fundingOpportunityId: data.fundingOpportunityId,
      process: data.process,
      task: data.task,
      whitelistUsers: whitelistUsers,
    };
  }

  doEntityAction(actionType, data, index) {
    switch (actionType) {
      case 'edit':
        this.handleEditModal(data);
        break;
      case 'remove':
        this.handleDeleteModal(data, index);
        break;
      default:
    }
  }

  handleDeleteModal = (data, index) => {
    this.setState({
      deleteModalOpen: true,
      data: data,
      index: index,
    });
  };

  renderWhitelist() {
    let {activePage, pageSize, whitelistData} = this.state;

    let actionOptions = [
      {
        key: 'edit',
        text: 'Edit',
        value: 'edit',
      },
      {
        key: 'remove',
        text: 'Remove',
        value: 'remove',
      },
    ];

    const entities = whitelistData;

    const entitiesToRender = _.slice(
      entities,
      (activePage - 1) * pageSize,
      activePage * pageSize
    );

    let rows = _.map(entitiesToRender, (data, index) => {
      let users = _.map(data.whitelistUsers, (userID, index) => {
        return (
          <Grid verticalAlign="bottom">
            <Grid.Row>
              <Grid.Column width={3} textAlign="left">
                {userID}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        );
      });
      return (
        <FemaGoTable.Row key={index}>
          <FemaGoTable.TextCell>{data.fundingOpportunityId}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{data.process}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{data.task}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell width={6}>{users}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            <Dropdown
              selectOnNavigation={false}
              selectOnBlur={false}
              text={'Actions'}
              options={actionOptions}
              onChange={(e, {name, value}) => {
                this.doEntityAction(value, data, index);
              }}
              value={''}
            />
          </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    });

    return (
      <React.Fragment>
        <Segment padded>
          <Grid
            key={'prescoreGrid'}
            doubling
            stackable
            reversed="mobile"
            padded="vertically"
            data-test="grid"
          >
            <Grid.Column className="visible-overflow">
              <Grid verticalAlign="bottom">
                <Grid.Row>
                  <Grid.Column width={8}>
                    <Header as="h3">{'Whitelist administration'}</Header>
                  </Grid.Column>
                  <Grid.Column width={3} textAlign="right" />
                  <Grid.Column width={5} textAlign="right">
                    <Button
                      primary
                      title="Add new whitelist"
                      id="addBtn"
                      onClick={(e) => {
                        // Show modal
                        this.handleAddModal();
                      }}
                    >
                      Add new whitelist
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <FemaGoTable type="entry" summary="Whitelist">
                <FemaGoTable.Header>
                  <FemaGoTable.Row>
                    <FemaGoTable.HeaderCell>
                      Funding opportunity id
                    </FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Process name</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Task name</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell width={6}>User id</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>
                  </FemaGoTable.Row>
                </FemaGoTable.Header>
                <FemaGoTable.Body>{rows}</FemaGoTable.Body>
              </FemaGoTable>

              {entities && entities.length > PAGE_SIZE ? (
                <div className="pagination-wrapper pagination" data-test="paginate">
                  <Pagination
                    totalPages={Math.ceil(entities.length / PAGE_SIZE)}
                    activePage={activePage}
                    onPageChange={(e, data) =>
                      this.setState({activePage: data.activePage})
                    }
                  />
                </div>
              ) : (
                ''
              )}
            </Grid.Column>
          </Grid>
        </Segment>
      </React.Fragment>
    );
  }

  renderAddEditWhitelistModal() {
    const {openModal, showModal} = this.state;
    let index = 0;

    return (
      <FemaGoModal
        title={showModal + ' whitelist'}
        buttonText="Confirm"
        open={openModal}
        size="large"
        confirmAction={() => {
          this.handleSubmit(this.state.data);
        }}
        cancelAction={() => {
          this.refreshData();
        }}
      >
        <FemaGoTable type="entry" summary="Whitelist">
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              <FemaGoTable.HeaderCell>Funding opportunity id</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Process name</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Task name</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>User id</FemaGoTable.HeaderCell>
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Body>
            <FemaGoTable.Row key={index}>
              <FemaGoTable.InputCell
                key={`{fundingOpportunityId + index}`}
                title="Funding opportunity"
                id="fundingOpportunityId"
                name="fundingOpportunityId"
                value={this.state.data.fundingOpportunityId}
                handleChange={(e, res) => {
                  this.handleChange(index, res);
                }}
                handleBlur={this.handleBlur}
                maxLength={501}
              />
              <FemaGoTable.InputCell
                key={`{process + index}`}
                id="process"
                title="Process name"
                name="process"
                value={this.state.data.process}
                handleChange={(e, res) => {
                  this.handleChange(index, res);
                }}
                handleBlur={this.handleBlur}
              />
              <FemaGoTable.InputCell
                key={`{task + index}`}
                title="Task name"
                id="task"
                name="task"
                value={this.state.data.task}
                handleChange={(e, res) => {
                  this.handleChange(index, res);
                }}
                handleBlur={this.handleBlur}
              />
              <FemaGoTable.InputCell
                width={6}
                key={`{whitelistUsers + index}`}
                title="Users"
                id="whitelistUsers"
                name="whitelistUsers"
                value={this.state.data.whitelistUsers}
                handleChange={(e, res) => {
                  this.handleChange(index, res);
                }}
                handleBlur={this.handleBlur}
                maxLength={5001}
              />
            </FemaGoTable.Row>
          </FemaGoTable.Body>
        </FemaGoTable>
      </FemaGoModal>
    );
  }

  renderDeleteModal() {
    return (
      <DeleteModal
        displayText={'Please confirm that you want to remove whitelist'}
        displayTitle={'Confirm remove'}
        open={this.state.deleteModalOpen}
        deleteAction={() => {
          this.handleDelete(this.state.data, this.state.index);
        }}
        cancelAction={() => {
          this.setState({
            deleteModalOpen: false,
          });
        }}
      />
    );
  }

  render() {
    let {openModal, deleteModalOpen, error} = this.state;
    return (
      <React.Fragment>
        {!error && this.renderWhitelist()}
        {openModal && this.renderAddEditWhitelistModal()}
        {deleteModalOpen && this.renderDeleteModal()}
      </React.Fragment>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({});

export const mapStateToProps = (state) => {
  return {
    currUserEmail: state.profile.emailAdr,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Whitelist);
